import type { MapMarker } from '../../models/MapModels';

// Ignore new object/callback identities from viewport queries; only visual or
// clustering changes require replacing a Google Maps marker.
export const getMarkerRenderKey = (marker: MapMarker): string => JSON.stringify([
  marker.id,
  marker.coordinate.latitude,
  marker.coordinate.longitude,
  marker.svgIcon,
  marker.accessibilityLabel,
  marker.defaultPin,
  marker.missionType,
  !!marker.isFlashMission,
  // Rebuild cached DOM markers when referral artwork or selection styling changes.
  marker.isReferral ? 'referral-pin-family-v3' : false,
  !!marker.isCompetitorPreview,
  marker.competitorCircuitRole,
]);
